module.exports = __webpack_public_path__ + "static/media/rod-and-elaine.f006c9a9.jpg";